export default async function handleLeadTierFilterChanges (eventValue, leadsAwaitingAction, teamInvestigatingLeads, teamClosingLeads, leadTypeFilter, leadNewFilter, leadTagFilter) {
  let awaitingAction = await handleFiltering(eventValue, leadsAwaitingAction, leadTypeFilter, leadNewFilter, leadTagFilter)
  let investigating = await handleFiltering(eventValue, teamInvestigatingLeads, leadTypeFilter, leadNewFilter, leadTagFilter)
  let closing = await handleFiltering(eventValue, teamClosingLeads, leadTypeFilter, leadNewFilter, leadTagFilter)
  return {awaitingAction, investigating, closing}
}

let handleFiltering = async (eventValue, leads, leadTypeFilter, leadNewFilter, leadTagFilter) => {
  let filteredLeads = []
  let filterTier = true
  if (eventValue === 'All') {
    filterTier = false
  } 
  for (let i = 0; i < leads.length; i++) {
    let pushLead = true
    if (filterTier) {
      if (eventValue === 'Tier 1') {
        if (leads[i].tier !== 1) {
          pushLead = false
        }
      } else if (eventValue === 'Tier 2') {
        if (leads[i].tier !== 2) {
          pushLead = false
        }
      } else {
        if (leads[i].tier !== 0) {
          pushLead = false
        }
      }
    }
    if (pushLead) {
      if (leadNewFilter === 'true' && !leads[i].newAssignmentNotification) {
        pushLead = false
      } else if (leadTypeFilter !== 'All') {
        if (leadTypeFilter === 'renegotiation') {
          if (leads[i].targetOutcome !== 'renegotiation') {
            pushLead = false
          }
        } else {
          if (leads[i].targetOutcome !== 'refinance') {
            pushLead = false
          }
        }
      } else if (leadTagFilter[0] !== 'All') {
        for (let j = 0; j < leadTagFilter.length; j++) {
          let matchingInvestigation = leads[i].tagIds.find(tag => tag === leadTagFilter[j])
          if (!matchingInvestigation) {
            pushLead = false
          }
        }
      }      
    }
    if (pushLead) {
      filteredLeads.push(leads[i])
    }
  }

  return filteredLeads
}